// extracted by mini-css-extract-plugin
export default {"container":"outline-title_container__kpYcx"};